import * as React from 'react';
import classnames from 'classnames';
import { Helpers } from '@grandvisionhq/inventory';
import { UpdateLineItemContainer } from '../containers/UpdateLineItemContainer.js';
import { RemoveLineItemContainer } from '../containers/RemoveLineItemContainer.js';
import { useCart } from '../../../context/Cart/context.js';

const QuantitySelector = ({ lineItemId , readOnly , hideQuantity  })=>{
    const { cart  } = useCart();
    const lineItem1 = cart === null || cart === void 0 ? void 0 : cart.lineItems.filter((lineItem)=>lineItem.id === lineItemId
    )[0];
    if (!lineItem1) {
        return null;
    }
    return !readOnly && !lineItem1.isGift ? /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__quantity-selector"
    }, !hideQuantity && /*#__PURE__*/ React.createElement(UpdateLineItemContainer, {
        lineItem: lineItem1,
        availableQuantity: Helpers.getAvailableQuantity(lineItem1.availability)
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames('line-item__delete-btn', hideQuantity ? 'line-item__delete-btn-noborder' : '')
    }, /*#__PURE__*/ React.createElement(RemoveLineItemContainer, {
        lineItem: lineItem1
    })))) : null;
};

export { QuantitySelector };
//# sourceMappingURL=QuantitySelector.js.map
